const getters = {
    getListSnapConsole: state => state.listSnapConsole,
    getPagination: state => state.pagination,
}

export default getters